<template>
  <div class="wrap">
    <div class="guide" :class="{'show-guide': isShow}">
      <div @click="()=>toPage(index)"
        :class="item.status == 'active' ? 'guide-box-active' : 'guide-box'"
        v-for="(item, index) in guidearr"
        :key="index"
      >
        {{item.name}}
      </div>
      <div class="guide-box" style="position:relative;" @mouseenter="onShowQrCode" @mouseleave="onHide">
        大赛咨询
        <div class="qr-img" v-show="showQr"><img src="../../assets/image/qr-code.jpg" /></div>
      </div>
      <a href="http://8.134.120.63:83/shouce.pdf" class="guide-box" style="display: block;color: #fff;position:relative;" target="_blank" download="旭麓新材料大赛手册">手册下载</a>
      <!-- <div class="qr-code"><img src="../../assets/image/match/qrcode.png" alt=""></div> -->
      <a href="javascript:void(0);" :title="isShow ? '收起': '展开'" @click="onShow" class="toggle-guide" :class="{'hide': !isShow}"></a>
    </div>
    <div class="pagew mid">
      <!-- <div class="text-introduce"><img src="../../assets/image/match/text.png" alt=""></div> -->
      <div class="banner-text-box" style="top: 380px">
        <p>“旭麓新材料”是全国首个以城市命名、由东莞市政府主办的大型国际工业设计竞赛活动。18年来，它为来自全球各地的设计师们提供了同台竞技的广阔舞台，肩负着“设计服务产业”的使命，“旭麓新材料”的名片在国际上越发闪亮，已发展成为海内外兼具知名度与影响力的工业设计赛事之一。</p>
        <p>本届大赛以“设计赋能产业，创新引领高质量发展”为主题，围绕东莞市制造业高质量发展的需求，大力提升工业设计创新能力，积极发挥工业设计对战略性产业集群建设的支撑和引领作用，为打造“东莞制造”和“东莞设计”区域品牌提供有力支撑。</p>
      </div>
      <div class="introduce">
        <div class="title" style="padding-top: 180px">
          <p style="height: 45px;"></p>
          <!-- <img style="width:186px" src="../../assets/image/match/cansai-title.jpg" alt=""> -->
        </div>
        <div class="title" style="padding-top: 40px">
          <img style="width:760px" src="../../assets/image/match/title1.png" alt="设计赋能产业，创新引领高质量发展">
        </div>
        <div class="text">围绕东莞市制造业高质量发展的需求，大力提升工业设计创新能力，积极发挥工业设计对战略性产业集群建设的支撑引领作用，为打造‘东莞制造”和“东莞设计”区域品牌提供有力支撑。</div>
      </div>
      <Roadgroup></Roadgroup>
      <Prize></Prize>
      <Process></Process>
      <Spotlight></Spotlight>
      <Judge></Judge>
      <News></News>
      <Signup></Signup>
    </div>
  </div>
</template>

<script>
import Roadgroup from '@/components/Match/roadgroup.vue'
import Prize from '@/components/Match/prize.vue'
import Process from '@/components/Match/process.vue'
import Spotlight from '@/components/Match/spotlight.vue'
import Judge from '@/components/Match/judge.vue'
import News from '@/components/Match/news'
import Signup from '@/components/Match/signup'
// import Header from "@/components/Header/Header";
export default {
  components: { Roadgroup,Prize,Process,Spotlight,Judge,News,Signup },
  name: "index",
  data() {
    return {
      showQr: false,
      isShow: true,
      guidearr: [{ name: "首页", status: "active", class: '.wrap' },
        { name: "大赛主题", status: "", class: '.introduce' },
        { name: "赛道组别", status: "", class: '.saidao-bg' },
        { name: "奖项设置", status: "", class: '.prize' },
        { name: "大赛流程", status: "", class: '.process' },
        { name: "大赛亮点", status: "", class: '.spotlight' },
        { name: "历届评委/仲裁委", status: "", class: '.judge' },
        { name: "新闻公告", status: "", class: '.news' },
        { name: "参赛报名", status: "", class: '.signup' },
        // { name: "大赛咨询", status: "", class: '.signup' },
        // { name: "手册下载", status: "", class: '.signup' }
      ]
    };
  },
  methods: {
    toPage(index) {
      for (let i in this.guidearr) {
        this.guidearr[i].status = ''
      }
      this.guidearr[index].status = 'active'
      let targetbox = document.querySelector(this.guidearr[index].class);
      document.documentElement.scrollTop = targetbox.offsetTop;
    },

    onShow() {
      this.isShow = !this.isShow;
    },

    onShowQrCode() {
      this.showQr = true;
    },
    onHide() {
      this.showQr = false;
    },
  },

  mounted() {
    const className = {
      '0': '#road-block1',
      '1': '#road-block2',
      '2': '#road-block3'
    }[this.$route.query.pos];
    if (className) {
      let targetbox = document.querySelector(className);
      console.log(targetbox);
      this.$nextTick(() => {
        document.documentElement.scrollTop = targetbox.offsetTop - 90;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-img {
  position: absolute;right: 100px;top: 50%;transform: translate(-100%, -50%);
  width: 120px;
  left: -15px;
}
.qr-img::before {
  content: '';
  width: 0;
  height: 0;border-width: 10px;border-color: transparent transparent transparent #fff;
  border-style: solid;
  position: absolute;top: 50%;transform: translateY(-50%);left: 120px;
}
.wrap {
  // padding-top: 1px;
  text-align: start;
  width: 100%;
  background: url("../../assets/image/match/bg.jpg") center top no-repeat;
}

.guide {
  position: fixed;
  right: 5px;
  top: 100px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  // overflow-y: auto;
  max-height: 731px;
  -webkit-overflow-scrolling: touch;
  overflow: -moz-scrollbars-none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  z-index: 5;
  transform: translateX(100%);
  transition: all .2s;
  /* IE 10+ */
  &::-webkit-scrollbar {
    display: none;
  }
}
.guide.show-guide {
  transform: translateX(0);
}
.guide .guide-box,

.guide-box-active {
  cursor: pointer;
  font-size: 14px;
  width: 120px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  /* padding:40px 60px; */
  margin-bottom: 3px;
  background-color: rgba(0, 0, 0, .5);
}
.text-introduce {
  width: 778px;
  position: absolute;left: 50%;top: 388px;
  transform: translate(-50%, 0);
}
.guide-box-active , .guide-box:hover {
  background-color: rgb(232, 201, 154);
}

.mid {
  position:relative;
  padding-top: 830px;
  background: url("../../assets/image/match/main.jpg") center 830px no-repeat;
  height: 10138px;
  height: 11050px;
  box-sizing: border-box;
}
.introduce {
  height: 654px;
  margin: auto;
  // background: url('../../assets/image/match/introduce-bg.jpg') no-repeat center top;
}

.introduce {
  .title {
    text-align: center;
    padding-top: 170px;
  }

  .text {
    margin: auto;
    padding-top: 40px;
    width: 760px;
    // font-weight: bold;
    line-height: 50px;
    text-indent: 46px;
    font-size: 24px;
    color: rgb(31, 0, 2)
  }
}
.toggle-guide {
  position: absolute;top: 30%;left: 0;
  transform: translateX(-118%);
  height: 42px*.6;z-index: 2;width: 24px*.6;opacity: .5;
  font-size: 0;
  background: url("../../assets/image/match/show-jt.png") center top no-repeat;
  background-size: contain;
  transition: all .2s;
  &:hover {
    opacity: .8;
  }
  &.hide {
    transform: translateX(-118%) rotate(180deg);
  }
}

@media screen and (max-width: 1280px) {
  .guide .guide-box,
  .guide-box-active {
    width: 100px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Match/index.vue